import React, {useEffect, useState} from "react";
import {Card, Input, message, Space, Table} from "antd";
import {TabButton} from "./TabButton";
import {getHostAddress} from "../../Tool/UtileFun"

export function TaskTable(){


    useEffect(
        ()=>{
            findTaskAll()
        },[]
    );



    const findTaskAll=()=>{
        fetch(
            "http://"+getHostAddress()+"/task/findAll",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setTask(data)
                console.log("findALL")
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    const searchStudent=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/task/findByNameLike",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({name:value}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setTask(data)
            })
            .catch(error => message.error("error"+error));
    }


    const [task,setTask]=useState([]);

    const { Search } = Input;

    const columns = [
        {
            title: '序号',
            width:80,
            render:(text,record,index)=>`${index+1}`

        },
        {
            title: '学生',
            dataIndex: 'student',
            key: 'student',
        },
        {
            title: '实验',
            dataIndex: 'experiment',
            key: 'experiment',
        },
        {
            title: '班级',
            dataIndex: 'cclass',
            key: 'cclass',
        },
        {
          title: "得分",
          dataIndex: "score",
          key:"score",
        },
        {
            title: '操作',
            key: 'details',
            render: (taskInfo) => (
                <>
                    <Space size="middle">
                        <TabButton props={taskInfo}
                                   Event={()=>{
                                       findTaskAll()
                                       console.log("执行了")
                                   }}
                        ></TabButton>
                    </Space>
                </>
            ),
        },

    ];


    return(
        <Card title={"作业批改"}>
            <Search placeholder="输入学生名称搜索"
                    onSearch={value => searchStudent(value)}
                    enterButton
                    style={{width:500}}/>
            <Table columns={columns} dataSource={task}></Table>
        </Card>
    )
}
